import React, { useState, useContext, useEffect } from "react";
import axios from "../../../../../axios/index";

// context
import { UserContext } from "../../../../Context/UserContextProvider";

import DashboardHeader from "../../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../../DashboardReuseAbleComponents/DashboardSideMenu";
import ShowProfileModal from "../../CardDetail/ShowProfileModal";
import { useHistory, useLocation, Link } from "react-router-dom";
import ConsultantReportsExpertReportForm from "./ConsultantReportsExpertReportForm";

// Styles
import styles from "./ConsultantReportsExpertReportDetails.module.css";
import Dstyles from "../../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../../assets/img/DashboardICons/ArrowRounded.svg";

const ConsultantReportsExpertReportEdit = props => {
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const [modalShow, setModalShow] = useState(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [formValue, setFormValue] = useState({
    exportTitle: "",
    area: "",
    ownerName: "",
    ownerPhone: "",
    code: "",
    price: "",
    exportResult: "",
    date: "",
    time: "",
    dateChanged: false,
  });

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const getConsultantReport = await axios.get(`ConsultantReport/GetReportById/${state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const data = getConsultantReport.data.data;
      // console.log(state)
      setFormValue(prev => {
        return {
          ...prev,
          exportTitle: data?.reportTitle,
          area: data?.area,
          ownerName: data?.ownerName,
          ownerPhone: data?.ownerPhoneNumber,
          code: data?.fileCode,
          price: data?.price,
          exportResult: data?.reportResult,
          date: data?.sReportDate,
          time: data?.sReportTime,
        };
        // date: data.reportDate,
        // time: data.reportTime
      });
      setIsLoading(false);
    };

    dataHandler();
  }, [userToken, state.id]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>گزارش کارشناسی</div>
                  </div>
                </div>

                {/* Total Form Consultant Reports Expert Report Details */}
                <ConsultantReportsExpertReportForm
                  formValue={formValue}
                  setFormValue={setFormValue}
                  setIsLoading={setIsLoading}
                  id={state.id}
                  estateId={state.estateId}
                />
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultantReportsExpertReportEdit;
